/**
 * Feedback Service
 * Handles user feedback (like/dislike) for assistant messages
 */

class FeedbackService {
  constructor() {
    this.apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  }

  /**
   * Submit feedback for a message
   * @param {Object} params - Feedback parameters
   * @param {string} params.sessionId - Current LiveKit room name
   * @param {string} params.messageText - The assistant message text
   * @param {string} params.feedbackAction - "like" or "dislike"
   * @param {string} params.clientUserId - User UUID
   * @param {string} params.token - Authentication token
   */
  async submitFeedback({ sessionId, messageText, feedbackAction, clientUserId, token }) {
    try {
      console.log('📊 Submitting feedback:', {
        sessionId,
        messageText: messageText.substring(0, 50) + '...',
        feedbackAction,
        clientUserId,
      });

      const payload = {
        session_id: sessionId,
        message_text: messageText,
        feedback_action: feedbackAction,
        feedback_text: "",
        client_session_id: "",
        client_user_id: clientUserId,
      };

      const response = await fetch(`${this.apiBaseUrl}/v1/external/post-feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Failed to submit feedback: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Feedback submitted successfully:', result);

      return { success: true, result };
    } catch (error) {
      console.error('❌ Failed to submit feedback:', error);
      return { success: false, error };
    }
  }
}

// Export singleton instance
export default new FeedbackService();

